import { FC } from 'react'

import { Layout } from '../../../containers'
import { Title, TextSummary, Card } from '../../../components/UI'
import { ControlPrevention } from '../../../components'

const ControlPreventionPage:FC = () => {
  return (
    <Layout menu titleMain={8}>
      <Title border>Control y Prevención</Title>

      <TextSummary className="mt-30">En esta sección podrás encontrar datos y recomendaciones saludables que serán de utilidad para ti y tu familia.</TextSummary>

      <Card showOnly="lg" className="lg:py-60 lg:px-60 mt-50 lg:mt-25">
        <ControlPrevention />
      </Card>
    </Layout>
  )
}

export { ControlPreventionPage }